import pyramidImg from '../../../image/Piramide_alwaysalignerssystem.png';
import './AasPillarsSection.css';

const PILLARS = [
  {
    id: 'diagnostico',
    tone: 1,
    title: 'Diagnóstico integral',
    body: (
      <>
        <p>
          Todo tratamiento comienza con un análisis diagnóstico completo del paciente. Se evalúan los
          aspectos esqueléticos, dentarios y funcionales, considerando los estudios clínicos y
          radiográficos necesarios, así como el criterio del profesional tratante.
        </p>
        <p className="aas-pillar__emphasis">Este primer pilar permite determinar:</p>
        <ul className="aas-pillar__list">
          <li>la indicación del tratamiento con alineadores,</li>
          <li>el grado de complejidad del caso,</li>
          <li>y la necesidad de recursos terapéuticos complementarios.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'planificacion',
    tone: 2,
    title: 'Planificación digital',
    body: (
      <>
        <p>
          Una vez analizado el caso, se desarrolla la planificación digital del tratamiento. A partir
          de los modelos digitales se realiza el setup ortodóncico, donde se definen los movimientos
          dentarios, la secuencia de etapas y el staging.
        </p>
        <p>
          El profesional recibe un visor digital que permite analizar el tratamiento antes de iniciar
          la producción, asegurando que cada movimiento esté correctamente planificado.
        </p>
      </>
    ),
  },
  {
    id: 'biomecanica',
    tone: 3,
    title: 'Biomecánica y estrategia terapéutica',
    body: (
      <>
        <p>
          El tercer pilar del sistema se basa en la correcta aplicación de los principios
          biomecánicos. Según las necesidades del caso pueden indicarse:
        </p>
        <ul className="aas-pillar__list">
          <li>aditamentos (attachments),</li>
          <li>desgastes interproximales,</li>
          <li>elásticos,</li>
          <li>microimplantes,</li>
          <li>o aparatología auxiliar.</li>
        </ul>
        <p>
          Este enfoque permite adaptar el tratamiento a cada paciente y mejorar la expresión de los
          movimientos planificados.
        </p>
      </>
    ),
  },
  {
    id: 'tecnologia',
    tone: 4,
    title: 'Tecnología de alineadores',
    body: (
      <>
        <p>
          Always Aligners ofrece distintas tecnologías de alineadores para adaptarse a cada situación
          clínica:
        </p>
        <ul className="aas-pillar__list aas-pillar__list--spaced">
          <li>
            <strong>Alineadores en placas PTG</strong>, indicados para casos simples o moderados.
          </li>
          <li>
            <strong>Alineadores multicapa</strong>, que ofrecen mayor control biomecánico.
          </li>
          <li>
            <strong>Alineadores de impresión directa (DAD)</strong>, diseñados para casos de mayor
            complejidad.
          </li>
        </ul>
        <p>La elección del material se realiza en función del diagnóstico y del plan de tratamiento.</p>
      </>
    ),
  },
  {
    id: 'acompanamiento',
    tone: 5,
    title: 'Acompañamiento profesional',
    body: (
      <>
        <p>El último pilar del sistema es el acompañamiento clínico.</p>
        <p>Always Aligners brinda soporte a los profesionales mediante:</p>
        <ul className="aas-pillar__list">
          <li>asesoramiento diagnóstico,</li>
          <li>discusión de casos,</li>
          <li>planificación terapéutica,</li>
          <li>y residencias clínicas presenciales.</li>
        </ul>
        <p>
          Este enfoque busca generar una red de profesionales que compartan criterios clínicos y
          puedan mejorar continuamente sus resultados.
        </p>
      </>
    ),
  },
];

const AasPillarsSection = () => {
  return (
    <section className="aas-section section section--lg" aria-labelledby="aas-heading">
      <div className="container">
        <header className="section-header aas-section__header">
          <p className="aas-section__eyebrow">Always Aligners System</p>
          <h2 id="aas-heading" className="section-title aas-section__title">
            <span className="aas-section__title-line">Un sistema basado en</span>
            <span className="title-accent aas-section__title-accent">cinco pilares</span>
          </h2>
          <div className="aas-section__intro">
            <p>
              Always Aligners no es únicamente un sistema de fabricación de alineadores. Es un modelo
              de trabajo clínico desarrollado por ortodoncistas, que integra diagnóstico, planificación
              digital, biomecánica y acompañamiento profesional para lograr tratamientos más
              predecibles.
            </p>
            <p>
              El sistema se estructura sobre cinco pilares fundamentales que permiten abordar cada caso
              de forma integral.
            </p>
          </div>
        </header>

        <div className="aas-pillars-layout">
          <ol className="aas-pillars__list">
            {PILLARS.map((pillar) => (
              <li
                key={pillar.id}
                id={pillar.id}
                className={`aas-pillar aas-pillar--tone-${pillar.tone}`}
              >
                <details className="aas-pillar__details">
                  <summary className="aas-pillar__summary">
                    <span className="aas-pillar__step" aria-hidden="true">
                      {pillar.tone}
                    </span>
                    <h3 className="aas-pillar__title">{pillar.title}</h3>
                    <span className="aas-pillar__chevron" aria-hidden="true" />
                  </summary>
                  <div className="aas-pillar__content">{pillar.body}</div>
                </details>
              </li>
            ))}
          </ol>

          <aside className="aas-pillars-layout__visual" aria-label="Gráfico de la pirámide del sistema">
            <figure className="aas-pyramid aas-pyramid--neutral">
              <img
                src={pyramidImg}
                alt="Pirámide Always Aligners: los cinco pilares del sistema, desde diagnóstico integral hasta acompañamiento profesional."
                loading="lazy"
                decoding="async"
              />
              <figcaption className="aas-pyramid__caption">
                Pirámide Always Aligners System
              </figcaption>
            </figure>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AasPillarsSection;
